import { Utils } from '../Utils';
import * as _ from "underscore";
import { EditAktivitet, newEmptyAktivitet } from './EditAktivitet';

window["initAlleAkt"] = (prosess, title) => {
    new AlleAkt("/Data/AlleAktiviteter", prosess, title);
};

class AlleAkt {
    mGrid: DevExpress.ui.dxDataGrid = null;
    mData: any;

    constructor(url: string, prosess: string, title: string) {
        Utils.wait("Laster ned alle aktiviteter");
        var myself: AlleAkt = this;
        $.getJSON(url, function (data) {
            myself.mData = data;
            var navn = "alle_" + title;
            var gridDiv = $('<div>')
                .addClass("internal-grid")
                .dxDataGrid({
                    dataSource: data.aktiviteter,
                    
                    rowAlternationEnabled: true,
                        columnAutoWidth: false,
                        //width: 1000,
                        allowColumnReordering: true,
                        allowColumnResizing: true,
                        columnChooser: {
                            enabled: true
                        },
                        columnFixing: {
                            enabled: true
                        },
                        filterRow: {
                            visible: true,
                            applyFilter: "auto"
                        },
                        selection: {
                            mode: "single"
                        },
                        headerFilter: {
                            visible: true
                        },
                        scrolling: {
                            //mode: "virtual",
                            showScrollbar: "always",
                            useNative: true
                        },
                        "export": {
                            enabled: true,
                            excelFilterEnabled: false,
                            fileName: "Eksport_" + "AlleAktiviteter",
                            proxyUrl: "/Home/Proxy"
                        },
                        noDataText: "Ingen data",
                        showBorders: true,
                        paging: {
                            pageSize: 20,
                        },
                        pager: {
                            showPageSizeSelector: true,
                            allowedPageSizes: [20, 50, 100],
                            showInfo: true
                        },
                    onRowClick: (e) => {
                        e.jQueryEvent.stopPropagation();
                        var component = e.component, prevClickTime = component.lastClickTime;
                        component.lastClickTime = new Date();
                        var isExpanded = e.component.isRowExpanded(e.key);
                        if (prevClickTime && !isExpanded && (component.lastClickTime - prevClickTime < 300))
                            new EditAktivitet(e.data, e.data.planId, () => myself.refreshGrid());
                    },
                        columns: [
                            {
                                dataField: 'id',
                                caption: 'Id',
                                width: 50,
                                fixed: true
                            },
                            {
                                dataField: 'aktId',
                                caption: 'AktId',
                                width: 60,
                                fixed: true
                            },
                            {
                                dataField: 'planId',
                                caption: 'Plan',
                                width: 200,
                                fixed: true,
                                calculateCellValue(rowData: any) {
                                    var plan = _.find(myself.mData.plans,
                                        (p: any) => {
                                            return p.id == rowData.planId;
                                        });
                                    if (plan != null)
                                        return plan.navn;
                                    return rowData.planId;
                                }
                            },
                            {
                                dataField: 'kontrollertDato',
                                caption: 'Kontrollert',
                                width: 100,
                                dataType: 'date',
                                fixed: true
                            },
                            {
                                dataField: 'erBatchJob',
                                caption: 'Batch',
                                width: 60,
                                dataType: 'boolean',
                                fixed: true
                            },
                            {
                                caption: 'Navn',
                                dataField: 'aktivitetsItem.navn',
                                width: 300,
                                fixed: true
                            }, {
                                dataField: 'dato',
                                caption: 'Produksjon',
                                dataType: 'date',
                                width: 70,
                                fixed: true
                            }, {
                                dataField: 'printFil',
                                caption: 'PrintFil',
                                dataType: 'date',
                                width: 70
                            }, {
                                dataField: 'printFilOverfort',
                                caption: 'Overført',
                                dataType: 'date',
                                width: 70
                            }, {
                                dataField: 'distribusjon',
                                caption: 'Distribusjon',
                                dataType: 'date',
                                width: 70
                            }, {
                                dataField: 'forfall',
                                caption: 'Forfall',
                                dataType: 'date',
                                width: 70,
                                calculateCellValue(rowData:any) {
                                    return Utils.fmtDateStr(rowData.forfall);
                                },
                            }, {
                                caption: 'Type',
                                dataField: 'ordreType.beskrivelse',
                                width: 100
                            }, {
                                caption: 'Prosess',
                                dataField: 'aktivitetsItem.prosess.navn',
                                width: 70
                            }, {
                                dataField: 'produksjonsType.navn',
                                caption: 'Produksjonstype',
                                width: 100
                            }, {
                                dataField: 'fakturaGruppe.navn',
                                caption: 'FakturaGruppe',
                                width: 130
                            }, {
                                dataField: 'cabOrderNr',
                                caption: 'Ordre',
                                width: 70
                            }, {
                                dataField: 'cabBatchId',
                                caption: 'Batch',
                                width: 70
                            },  {
                                dataField: 'antallPlanlagt',
                                caption: 'Priv. planl.',
                                width: 80
                            }, {
                                dataField: 'antallProdusert',
                                caption: 'Priv. prod.',
                                width: 80
                            }, {
                                dataField: 'antalPlanlagtNaering',
                                caption: 'Nær. planl.',
                                width: 80
                            }, {
                                dataField: 'antalProdusertNaering',
                                caption: 'Nær. prod.',
                                width: 80
                            },{
                                dataField: 'merknader',
                                caption: 'Merknader',
                                width: 150
                            }
                        ],
                    masterDetail: null
                });
            $("#AlleAktiviteter_AlleAkt").append("<div class='btnRefreshAll'/>");
            $(".btnRefreshAll").dxButton({
                icon: "refresh",
                text: "Oppdater",
                onClick: (e) => {
                    myself.refreshGrid();
                }
            });
            $("#AlleAktiviteter_AlleAkt").append(gridDiv);

            myself.mGrid = gridDiv.dxDataGrid("instance");
            Utils.finished();
        });
        //gridDiv.dxDataGrid("instance");
    }

    refreshGrid() {
        var self: AlleAkt = this;
        $.getJSON("/Data/AlleAktiviteter", (data) => {
            self.mGrid.option("dataSource", data);
            self.mGrid.refresh();
        });
    }
}


// WEBPACK FOOTER //
// ./TS/Plan/AlleAktiviteter.ts